if (import.meta.hot) {
  import.meta.hot.accept();
}

import '../Scss/header-search.scss';
import { createAutosuggest } from '@assets/JavaScript/lib/autosuggest';

const initHeaderSearch = (header) => {
  const trigger = header.querySelector('[data-header-search-trigger]');
  const form = header.querySelector('[data-header-search-form]');
  const input = form?.querySelector('[data-header-search-input]');
  const clear = form?.querySelector('[data-header-search-clear]');
  const submit = form?.querySelector('.header__search-submit');
  const suggest = form?.querySelector('[data-header-search-suggest]');

  if (!trigger || !form || !input) {
    return;
  }

  const stripAriaExpanded = new MutationObserver(() => {
    if (input.hasAttribute('aria-expanded')) {
      input.removeAttribute('aria-expanded');
    }
  });
  stripAriaExpanded.observe(input, {
    attributes: true,
    attributeFilter: ['aria-expanded'],
  });

  const suggestUrl = form.getAttribute('data-suggest-url') ?? '';

  const { close: closeSuggestions } = createAutosuggest({
    input,
    suggest,
    suggestUrl,
    formAction: form.getAttribute('action') ?? '#',
    itemClassName: 'header__search-suggest-item',
    linkClassName: 'header__search-suggest-link copy-03-regular',
  });

  const setActiveState = (active) => {
    header.classList.toggle('is-search-open', active);
    trigger.setAttribute('aria-expanded', active ? 'true' : 'false');
    form.hidden = !active;
  };

  const updateClearVisibility = () => {
    if (!clear) {
      return;
    }

    clear.hidden = input.value.length === 0;
  };

  const closeSearch = (restoreFocus = false) => {
    setActiveState(false);
    closeSuggestions();

    if (restoreFocus) {
      trigger.focus({ preventScroll: true });
    }
  };

  const openSearch = () => {
    setActiveState(true);
    updateClearVisibility();
    input.focus({ preventScroll: true });
  };

  trigger.addEventListener('click', (event) => {
    event.preventDefault();

    if (header.classList.contains('is-search-open')) {
      closeSearch(true);
    } else {
      openSearch();
    }
  });

  input.addEventListener('input', updateClearVisibility);

  clear?.addEventListener('click', () => {
    input.value = '';
    updateClearVisibility();
    closeSuggestions();
    input.focus({ preventScroll: true });
  });

  [clear, submit].forEach((button) => {
    button?.addEventListener('mousedown', (event) => {
      event.preventDefault();
    });
  });

  form.addEventListener('submit', (event) => {
    if (!input.value.trim()) {
      event.preventDefault();
      input.focus();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && header.classList.contains('is-search-open')) {
      closeSearch(true);
    }
  });

  document.addEventListener('click', (event) => {
    if (!header.classList.contains('is-search-open')) {
      return;
    }

    if (!(event.target instanceof Node)) {
      return;
    }

    if (!header.contains(event.target)) {
      closeSearch();
    }
  });

  form.addEventListener('focusout', (event) => {
    if (!header.classList.contains('is-search-open')) {
      return;
    }
    if (event.relatedTarget && form.contains(event.relatedTarget)) {
      return;
    }
    closeSearch(true);
  });

  document.addEventListener('sidebar:beforeopen', () => closeSearch());
  header.addEventListener('header:flyoutopen', () => closeSearch());
  header.addEventListener('header:mobileopen', () => closeSearch());
};

document.querySelectorAll('[data-header]').forEach((header) => initHeaderSearch(header));
